// AllComponents.js

import React from "react";
import Home from "./Home";
import About from "./About";
import Education from "./Education";
import Project from "./Project";
import Contact from "./Contact";

function AllComponents() {
  return (
    <>
      <Home />
      <About />
      <Education />
      <Project />
      <Contact />
    </>
  );
}

export default AllComponents;
